const TopBanner = () => (
  <div className="bg-[#A3E635] text-[#1E0750] text-center py-2.5 px-4 text-sm font-bold">
    <a href="https://www.instagram.com/luc.saudemont/" target="_blank" rel="noopener noreferrer" className="underline hover:opacity-80 cursor-pointer"><strong>Abonne toi sur mon compte Instagram</strong></a>
  </div>
);

export default TopBanner;
